// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__UL_Rj","amenities":"styles_amenities__Wd3n_","requirements":"styles_requirements__BBMpT"};